var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8171",
    "data-name": "Path 8171",
    d: "M19,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3ZM13.56,6.53h0a.754.754,0,0,1,1.06,0l.88.88.88-.88a.754.754,0,0,1,1.06,0h0a.754.754,0,0,1,0,1.06l-.88.88.88.88a.754.754,0,0,1,0,1.06h0a.754.754,0,0,1-1.06,0l-.88-.87-.88.88a.754.754,0,0,1-1.06,0h0a.754.754,0,0,1,0-1.06l.88-.88-.88-.88A.749.749,0,0,1,13.56,6.53ZM7,7.72h3.5a.755.755,0,0,1,.75.75h0a.755.755,0,0,1-.75.75H7a.755.755,0,0,1-.75-.75h0A.755.755,0,0,1,7,7.72ZM10.75,16H9.5v1.25a.755.755,0,0,1-.75.75h0A.755.755,0,0,1,8,17.25V16H6.75A.755.755,0,0,1,6,15.25H6a.755.755,0,0,1,.75-.75H8V13.25a.755.755,0,0,1,.75-.75h0a.755.755,0,0,1,.75.75V14.5h1.25a.755.755,0,0,1,.75.75h0A.755.755,0,0,1,10.75,16Zm6.5,1.25h-3.5A.755.755,0,0,1,13,16.5h0a.755.755,0,0,1,.75-.75h3.5a.755.755,0,0,1,.75.75h0A.755.755,0,0,1,17.25,17.25Zm0-2.5h-3.5A.755.755,0,0,1,13,14h0a.755.755,0,0,1,.75-.75h3.5A.755.755,0,0,1,18,14h0A.755.755,0,0,1,17.25,14.75Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceDepartment);
export default __webpack_public_path__ + "static/media/finance_department.96c7c80044458227b93e0a50b39f2f52.svg";
export { ForwardRef as ReactComponent };